import $ from '../../plugins/query';

export default class iOSController {
    constructor() {
        if (!iOSController.isIOS())
            return;
        this.removeDecimalInputMode();
    }

    removeDecimalInputMode(){
        $('input[inputmode="decimal"]').each(function(e){
            if(e.dataset.removeInputmodeIos == "true")
                e.attributes.inputmode.value = 'text';
        });
    }

    static isIOS(){
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            new iOSController(); // eslint-disable-line no-new
        });
    }
}